namespace Ir.Components.Workbook.ToolBar.CreateDashboardToolBar {
    interface ICreateDashboardToolBarViewModel {
        buttonOptions: any,
    }

    export function getViewModel(this: ICreateDashboardToolBarViewModel, params: any) {
        this.buttonOptions = {
            hint: 'Add a new Dashboard tab',
            template: `<i class="ms ms-white ms-bold">add</i> ${(params.text ?? "Dashboard")}`,
            stylingMode: 'contained',
            type: 'default',
            onClick(e) {
                workbook.workbookConfig.workbookHelper.addTab(TabTypeEnum.Dashboard, new ReportStub({ id: 0, name: "New Dashboard" }));
            },
            visible: workbook.workbookConfig.generalSettings.editing
        }
    }
}